/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProjectConfigRequestDto } from '../../models/backend-patched-project-config-request-dto';
import { BackendProjectConfigDto } from '../../models/backend-project-config-dto';

export interface ProjectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedProjectConfigRequestDto;
}

export function projectsProjectConfigPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectConfigPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectConfigDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectConfigPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectConfigDto>;
    }),
  );
}

projectsProjectConfigPartialUpdate$XWwwFormUrlencoded.PATH = '/api/projects/project-config/{id}/';
